import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import createaction from "../../context/action/broke/createaction";
import getaction from "../../context/action/broke/getaction";
import Brokelist from "./brokelist";

const Broke = () => {
    const { initState, recaller, setrecaller, initDispatch, clear } =
    useContext(GlobalContext);
    const [barcode,setbarcode]=useState();
    const [qty,setqty]=useState();
    const [from,setfrom]=useState();
    const [to,setto]=useState();

    const [error,seterror]=useState(false);
    const [error1,seterror1]=useState(false);
    const [error2,seterror2]=useState(false);
    const [error3,seterror3]=useState(false);
    
  return (
    <div className="min-h-screen bg-slate-50 p-6 md:p-8">
      {/* Page Header */}
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">خەسار</h1>
          <p className="text-sm text-slate-400 mt-0.5">بینین و بەڕێوەبردنی کاڵای خەسار</p>
        </div>
      </div>

      {/* Add Broke Item Form */}
      <div className="bg-white border border-slate-100 rounded-xl p-6 mb-6 shadow-sm">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 items-end">
        <div className="w-full">
          <label
            className={
              error
                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                : "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
            htmlFor="barcode"
          >
            کۆد
          </label>
          <input
            className={
              error
                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            id="barcode"
            type="text"
            placeholder=""
            value={barcode}
            onChange={(val) => setbarcode(val.target.value)}
            onFocus={() => seterror(false)}
          />
        </div>
        <div className="w-full">
          <label
            className={
              error1
                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                : "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
            htmlFor="qty"
          >
            بڕی خەسار
          </label>
          <input
            className={
              error1
                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            id="qty"
            type="number"
            placeholder=""
            value={qty}
            onChange={(val) => setqty(val.target.value)}
            onFocus={() => seterror1(false)}
          />
        </div>
        <div className="w-full">
          <button
            className="h-10 px-6 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full"
            onClick={() => {
              if (barcode == "" || !barcode) {
                seterror(true);
                return false;
              }
              if (qty < 0 || !qty) {
                seterror1(true);
                return false;
              }
              createaction(barcode,qty,initState.token.user_id)(recaller)(setrecaller)(initDispatch)(clear);
            }}
          >
            زیادکردن
          </button>
        </div>
      </div>
    </div>

      {/* Broke List Filter Section */}
      <div className="mt-8">
        <h2 className="text-lg font-bold text-slate-800 mb-6">لیستی خەسار</h2>
        <div className="bg-white border border-slate-100 rounded-xl p-6 mb-6 shadow-sm">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 items-end">
          <div className="w-full">
            <label
              className={
                error2
                  ? "block text-sm font-medium text-red-500 mb-1 text-right"
                  : "block text-sm font-medium text-slate-500 mb-1 text-right"
              }
              htmlFor="date_from"
            >
              لە بەرواری
            </label>
            <input
              className={
                error2
                  ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                  : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
              }
              id="date_from"
              type="date"
              placeholder=""
              value={from}
              onChange={(val) => setfrom(val.target.value)}
              onFocus={() => seterror2(false)}
            />
          </div>
          <div className="w-full">
            <label
              className={
                error3
                  ? "block text-sm font-medium text-red-500 mb-1 text-right"
                  : "block text-sm font-medium text-slate-500 mb-1 text-right"
              }
              htmlFor="date_to"
            >
              بۆ بەرواری
            </label>
            <input
              className={
                error3
                  ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                  : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
              }
              id="date_to"
              type="date"
              placeholder=""
              value={to}
              onChange={(val) => setto(val.target.value)}
              onFocus={() => seterror3(false)}
            />
          </div>
          <div className="w-full">
            <button
              className="h-10 px-6 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full"
              onClick={() => {
                if (from == "" || !from) {
                  seterror2(true);
                  return false;
                }
                if (to == "" || !to) {
                  seterror3(true);
                  return false;
                }
                getaction(from,to)(recaller)(setrecaller)(initDispatch)(clear);
              }}
            >
              گەڕان
            </button>
          </div>
        </div>
        </div>
      </div>

      {/* Broke List Section */}
       <div>
         {initState.broke.length>0?<Brokelist />:null}
       </div>
    </div>

  )
}

export default Broke